import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

function Cart() {
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState([]);

    useEffect(() => {
        const storedCart = localStorage.getItem('cart');
        if (storedCart) {
            setCartItems(JSON.parse(storedCart));
        }
    }, []);

    const updateCart = (newCart) => {
        setCartItems(newCart);
        localStorage.setItem('cart', JSON.stringify(newCart));
    };

    const removeItem = (index) => {
        const newCart = [...cartItems];
        newCart.splice(index, 1);
        updateCart(newCart);
    };

    const updateQuantity = (index, change) => {
        const newCart = [...cartItems];
        if (newCart[index].quantity + change > 0) {
            newCart[index].quantity += change;
            updateCart(newCart);
        }
    };

    const calculateTotal = () => {
        return cartItems.reduce((total, item) => total + (parseInt(item.price) * (item.quantity || 1)), 0);
    };

    const handleCheckout = () => {
        let message = "I would like to place an order for:\n";
        cartItems.forEach(item => {
            message += `${item.service_name} x ${item.quantity || 1} - ₹${item.price * (item.quantity || 1)}\n`;
        });
        message += `\nTotal: ₹${calculateTotal()}`;
        window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
    };

    // SVG Data URI for placeholder
    const PLACEHOLDER_IMG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f1f5f9'/%3E%3Ctext x='50' y='50' font-family='sans-serif' font-size='14' text-anchor='middle' dy='.3em' fill='%2364748b'%3ENo Image%3C/text%3E%3C/svg%3E";

    // Helper to get the best available image URL
    const getImageUrl = (item) => {
        if (item.featured_image) {
            return item.featured_image.startsWith('http') 
                ? item.featured_image 
                : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`;
        }
        if (item.icon) {
             return item.icon.startsWith('http') 
                ? item.icon 
                : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`;
        }
        return null; 
    };

    const handleImageError = (e) => {
        e.target.src = PLACEHOLDER_IMG;
    };

    const totalAmount = calculateTotal();

    return (
        <>
            <Navbar />
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

                :root {
                    --cart-bg: #f8f9fc;
                    --card-bg: #ffffff;
                    --text-primary: #1e293b;
                    --text-secondary: #64748b;
                    --accent: #2563eb;
                    --accent-hover: #1d4ed8;
                    --danger: #ef4444;
                    --border: #e2e8f0;
                    --shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                }

                .cart-wrapper {
                    font-family: 'Plus Jakarta Sans', sans-serif;
                    background-color: var(--cart-bg);
                    min-height: 80vh;
                    padding: 60px 0;
                }

                .cart-title {
                    font-size: 2rem;
                    font-weight: 700;
                    color: var(--text-primary);
                    margin-bottom: 2rem;
                }

                .cart-container {
                    display: grid;
                    grid-template-columns: 1fr 380px;
                    gap: 40px;
                }

                /* Empty State */
                .empty-cart {
                    text-align: center;
                    padding: 80px 20px;
                    background: var(--card-bg);
                    border-radius: 20px;
                    box-shadow: var(--shadow);
                }
                .empty-icon {
                    font-size: 4rem;
                    color: var(--text-secondary);
                    margin-bottom: 20px;
                    opacity: 0.5;
                }

                /* Cart Item */
                .cart-item {
                    background: var(--card-bg);
                    border-radius: 16px;
                    padding: 24px;
                    margin-bottom: 20px;
                    display: grid;
                    grid-template-columns: 100px 1fr auto auto;
                    gap: 24px;
                    align-items: center;
                    border: 1px solid var(--border);
                    transition: transform 0.2s, box-shadow 0.2s;
                }
                .cart-item:hover {
                    box-shadow: var(--shadow);
                    border-color: #cbd5e1;
                }

                .item-img {
                    width: 100px;
                    height: 100px;
                    border-radius: 12px;
                    object-fit: cover;
                    background: #f1f5f9;
                }

                .item-info h4 {
                    font-size: 1.1rem;
                    font-weight: 600;
                    color: var(--text-primary);
                    margin-bottom: 8px;
                }

                .item-price {
                    color: var(--text-secondary);
                    font-size: 0.95rem;
                }
                
                .qty-control {
                    display: flex;
                    align-items: center;
                    background: #f1f5f9;
                    border-radius: 10px;
                    padding: 4px;
                }

                .qty-btn {
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    background: white;
                    border-radius: 8px;
                    cursor: pointer;
                    color: var(--text-primary);
                    font-weight: 600;
                    transition: 0.2s;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                }
                .qty-btn:hover {
                    background: var(--accent);
                    color: white;
                }

                .qty-val {
                    width: 40px;
                    text-align: center;
                    font-weight: 600;
                    color: var(--text-primary);
                }

                .remove-btn {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    border: 1px solid var(--border);
                    background: white;
                    color: var(--text-secondary);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: 0.2s;
                }
                .remove-btn:hover {
                    background: #fee2e2;
                    border-color: #fca5a5;
                    color: var(--danger);
                }

                .item-subtotal {
                    font-weight: 700;
                    font-size: 1.1rem;
                    color: var(--text-primary);
                    text-align: right;
                }

                /* Summary Card */
                .summary-card {
                    background: var(--card-bg);
                    border-radius: 20px;
                    padding: 32px;
                    box-shadow: var(--shadow);
                    height: fit-content;
                    border: 1px solid var(--border);
                    position: sticky;
                    top: 100px;
                }

                .summary-title {
                    font-size: 1.25rem;
                    font-weight: 700;
                    margin-bottom: 24px;
                    color: var(--text-primary);
                }

                .summary-row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 16px;
                    color: var(--text-secondary);
                    font-size: 0.95rem;
                }

                .summary-divider {
                    border-top: 2px dashed var(--border);
                    margin: 20px 0;
                }

                .total-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: var(--text-primary);
                    margin-bottom: 30px;
                }

                .btn-checkout {
                    width: 100%;
                    padding: 16px;
                    background: var(--accent);
                    color: white;
                    border: none;
                    border-radius: 12px;
                    font-weight: 600;
                    font-size: 1rem;
                    cursor: pointer;
                    transition: 0.2s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                }
                .btn-checkout:hover {
                    background: var(--accent-hover);
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
                }

                .btn-back {
                    width: 100%;
                    padding: 16px;
                    background: transparent;
                    color: var(--text-secondary);
                    border: none;
                    font-weight: 600;
                    cursor: pointer;
                    margin-top: 10px;
                    transition: 0.2s;
                }
                .btn-back:hover {
                    color: var(--text-primary);
                }

                .item-img-placeholder {
                    width: 100px;
                    height: 100px;
                    border-radius: 12px;
                    background: #e2e8f0;
                    color: var(--text-secondary);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    font-weight: 700;
                    text-transform: uppercase;
                }

                @media (max-width: 992px) {
                    .cart-container {
                        grid-template-columns: 1fr;
                    }
                    .summary-card {
                        position: static;
                    }
                }

                @media (max-width: 576px) {
                    .cart-item {
                        grid-template-columns: 80px 1fr;
                        grid-template-areas: 
                            "img info"
                            "img info"
                            "qty price";
                        gap: 16px;
                    }
                    .item-img {
                        grid-area: img;
                        width: 80px;
                        height: 80px;
                    }
                    .item-info {
                        grid-area: info;
                    }
                    .qty-control {
                        grid-area: qty;
                        width: fit-content;
                    }
                    .item-subtotal {
                        grid-area: price;
                    }
                    .remove-btn {
                        position: absolute;
                        top: 16px;
                        right: 16px;
                        width: 32px;
                        height: 32px;
                        border: none;
                    }
                    .cart-item {
                        position: relative;
                    }
                }
            `}</style>

            <div className="cart-wrapper">
                <div className="container">
                    <h2 className="cart-title">Shopping Cart <span style={{fontSize: '1rem', color: 'var(--text-secondary)', fontWeight: 'normal'}}>({cartItems.length} items)</span></h2>

                    {cartItems.length === 0 ? (
                        <div className="empty-cart">
                            <div className="empty-icon">🛒</div>
                            <h3 style={{marginBottom: '1rem', color: 'var(--text-primary)'}}>Your cart is currently empty</h3>
                            <p style={{color: 'var(--text-secondary)', marginBottom: '2rem'}}>Looks like you haven't added anything to your cart yet.</p>
                            <button className="btn-checkout" style={{maxWidth: '300px', margin: '0 auto'}} onClick={() => navigate(-1)}>
                                Start Shopping
                            </button>
                        </div>
                    ) : (
                        <div className="cart-container">
                            <div className="cart-items">
                                {cartItems.map((item, index) => (
                                    <div className="cart-item" key={index}>
                                        {getImageUrl(item) ? (
                                            <img 
                                                className="item-img"
                                                src={getImageUrl(item)}
                                                onError={handleImageError}
                                                alt={item.service_name} 
                                            />
                                        ) : (
                                            <div className="item-img-placeholder">
                                                {(item.service_name || 'PR').slice(0, 2).toUpperCase()}
                                            </div>
                                        )}
                                        
                                        <div className="item-info">
                                            <h4>{item.service_name}</h4>
                                            <div className="item-price">Unit Price: ₹{item.price}</div>
                                        </div>

                                        <div className="qty-control">
                                            <button className="qty-btn" onClick={() => updateQuantity(index, -1)}>−</button>
                                            <span className="qty-val">{item.quantity || 1}</span>
                                            <button className="qty-btn" onClick={() => updateQuantity(index, 1)}>+</button>
                                        </div>

                                        <div style={{textAlign: 'right'}}>
                                            <div className="item-subtotal">₹{parseInt(item.price) * (item.quantity || 1)}</div>
                                            <button className="remove-btn" onClick={() => removeItem(index)} style={{marginLeft: 'auto', marginTop: '10px'}}>
                                                🗑️
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="summary-section">
                                <div className="summary-card">
                                    <h3 className="summary-title">Order Summary</h3>
                                    
                                    <div className="summary-row">
                                        <span>Subtotal</span>
                                        <span>₹{totalAmount}</span>
                                    </div>
                                    <div className="summary-row">
                                        <span>Shipping</span>
                                        <span style={{color: '#16a34a'}}>Free</span>
                                    </div>
                                    <div className="summary-row">
                                        <span>Tax (Estimated)</span>
                                        <span>₹0</span>
                                    </div>

                                    <div className="summary-divider"></div>

                                    <div className="total-row">
                                        <span>Total</span>
                                        <span>₹{totalAmount}</span>
                                    </div>

                                    <button className="btn-checkout" onClick={handleCheckout}>
                                        Proceed to Checkout →
                                    </button>
                                    
                                    <button className="btn-back" onClick={() => navigate(-1)}>
                                        Continue Shopping
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Cart;
